import { donationsByUserId } from '@/entities/donations'
import { HidingSpin } from '@/shared/ui'
import { UserOutlined } from '@ant-design/icons'
import { Avatar, Space, Typography } from 'antd'
import { useUnit } from 'effector-react'

const { Text } = Typography

export const DonationsByUserIdUserInfoCard = () => {
  const { data, pending, error } = useUnit(donationsByUserId)

  return (
    <HidingSpin spinning={pending || (!data && !error)}>
      <Space align="center">
        <Avatar
          size={64}
          src={data?.picture?.fullCdnUrl}
          icon={data?.picture?.fullCdnUrl ? undefined : <UserOutlined />}
        />
        <div>
          <Text strong>{data?.nickname}</Text>
          <br />
          {data?.phoneNumber && (
            <Text type="secondary">{data?.phoneNumber}</Text>
          )}
        </div>
      </Space>
    </HidingSpin>
  )
}
